import { useAppSelector } from "@/redux/store";

import emailIcon from "@/assets/icons/email.svg";
import addressIcon from "@/assets/icons/addressMark.svg";
import phoneIcon from "@/assets/icons/phoneBlack.svg";
import whatsAppIcon from "@/assets/icons/whatsApp.svg";
import telegramIcon from "@/assets/icons/telegram.svg";
import styles from "./ContactsInfo.module.scss";

export const ContactsInfo = () => {
  const { contactsInfo } = useAppSelector(state => state.contacts);

  const handleClearPhoneAndMessenger = (phone: string) => {
    return phone.replace(/[^\d+]/g, '');
  }

  return (
    <div className={styles.info}>
      <div className={styles.info_item}>
        <div className={styles.info_item_label}>
          <img src={emailIcon} alt="email icon" />
          <span>
            Электронная почта
          </span>
        </div>
        <div className={styles.info_item_content}>
          <a href = {`mailto:${contactsInfo.email || 'info@tennis.ru'}`}>
            <span>
              {contactsInfo.email || 'info@tennis.ru'}
            </span>        
          </a>
        </div>
      </div>

      <div className={styles.info_item}>
        <div className={styles.info_item_label}>
          <img src={addressIcon} alt="address icon" />
          <span>
            Адрес
          </span>
        </div>
        <div className={styles.info_item_content}>
          <a target="_blank" href={'https://yandex.ru/maps/213/moscow/house/malaya_letovskaya_ulitsa_8/Z04YcgZgSUwAQFtvfXl2cX1gZQ==/?ll=37.410097%2C55.570131&z=17.1'} rel="noreferrer">
            <span>
              {contactsInfo.address || 'г. Москва, ул. Летовская Малая, 8'}
            </span>
          </a>
        </div>
      </div>

      <div className={styles.info_item}>
        <div className={styles.info_item_content}>
          <a href={`tel:${handleClearPhoneAndMessenger(contactsInfo.phone) || '+74951505599'}`}>
            <img src={phoneIcon} alt="phone icon" />
            <span>
              {contactsInfo.phone || '+7 (495) 150-55-99'}
            </span>
          </a>
        </div>
      </div>

      <div className={styles.info_item}>
        <div className={styles.info_item_content}>
          <a target="_blank" href={`https://wa.me/${handleClearPhoneAndMessenger(contactsInfo.messenger_1) || '+79035564444'}?text=Привет!`} rel="noreferrer">
            <img src={whatsAppIcon} alt="whatsApp icon" />
            <span>
              {contactsInfo.messenger_1 || '+7 (903) 556-44-44'}
            </span>
          </a>
        </div>
      </div>

      <div className={styles.info_item}>
        <div className={styles.info_item_content}>
          <a target="_blank" href={`https://t.me/${handleClearPhoneAndMessenger(contactsInfo.messenger_2) || '+79035564444'}`} rel="noreferrer">
            <img src={telegramIcon} alt="telegram icon" />
            <span>
              {contactsInfo.messenger_2 || '+7 (903) 556-44-44'}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};